const state = {
    unique: localStorage.getItem('unique') || ''
}
const mutations = {
    UNIQUE: (state, unique) => {
        state.unique = unique
    }
}
const actions = {
    unique({
        commit
    }, result) {
        commit("UNIQUE", result || unique)
        localStorage.setItem('unique', result)
    }
}
export default {
    namespaced: true,
    state,
    mutations,
    actions
}